var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"body"}},[(!this.$route.path.match(/home/))?_c('div',[_c('navigation-drawer',{attrs:{"nav_list":_vm.nav_list}})],1):_vm._e(),_c('v-main',[_c('div',{},[_c('router-view',{attrs:{"nav_list":_vm.nav_list}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }